import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useLeagueContext } from "@/modules/leagues/hooks/useLeagueContext";
import { ROUTES } from "@/constants/routes";

/**
 * Bloqueia páginas de configuração que não têm versão só-leitura (Config.
 * da rodada, Selecionar Clubes, Importar Pontos, Perguntas Bônus) — sem
 * isso, esconder o item do menu não impede um não-ADM de acessar via URL
 * direta. Redireciona pro menu principal de Configurações (que já mostra
 * só o que ele pode ver).
 */
export function AdminOnlyGuard({ children }: { children: ReactNode }) {
  const { league } = useLeagueContext();
  const canManage = league.myRole === "admin" || league.myRole === "moderator";
  if (!canManage) return <Navigate to={ROUTES.leagueSettings(league.id)} replace />;
  return <>{children}</>;
}
